import { api, downloadFile } from "@/lib/api";

export interface BulkColumn {
  name: string;
  required: boolean;
  example: string;
  help: string;
}

export interface BulkResource {
  key: string;
  label: string;
  description: string;
  permission: string;
  columns: BulkColumn[];
}

export interface BulkRowError {
  row: number;
  error: string;
}

export interface BulkImportResult {
  resource: string;
  total: number;
  created: number;
  failed: number;
  errors: BulkRowError[];
}

export function listBulkResources(): Promise<BulkResource[]> {
  return api.get<BulkResource[]>("/bulk-import/resources");
}

export function downloadSample(resource: string): Promise<void> {
  return downloadFile(`/bulk-import/${resource}/sample`, `${resource}-sample.csv`);
}

export function importCsv(resource: string, file: File): Promise<BulkImportResult> {
  const form = new FormData();
  form.append("file", file);
  return api.upload<BulkImportResult>(`/bulk-import/${resource}`, form);
}
